import React, { useCallback } from 'react'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import { createUseStyles } from 'react-jss'
import { ListError, PageHeader } from '../../Common'
import { useIsAdmin, useFeatureGuard } from '../../../redux/slices/session'
import api from '../../../api'
import { useAsync } from '../../../hooks'
import MonthFilter from '../../Common/MonthFilter'
import Filters from '../../Forms/Filters'
import useFilters from './useFilters'
import BillingOrders from './BillingOrders'

const DEFAULT_FILTERS = {
  checkDate: moment()
    .startOf('month')
    .format('YYYY-MM'),
  query: '',
  page: 1,
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    '& > form': {
      flex: '1',
      minWidth: '135px',
    },
  },
})

export default function OfficeBillingOrders() {
  const { practiceId } = useParams()
  const isAdmin = useIsAdmin()
  const classes = useStyles()
  const getPractice = useCallback(() => api.practices.getPractice(practiceId), [
    practiceId,
  ])
  const { pending, value: practice, error, clearError } = useAsync(getPractice)

  const { handleFilterChange, handlePageChange, conditions } = useFilters(
    DEFAULT_FILTERS,
  )

  const { page, checkDate, query } = conditions
  useFeatureGuard('in_office_checks')

  if (checkDate && !pending) {
    return (
      <div>
        <PageHeader
          title="Office Billing Orders"
          subTitle={isAdmin && practice.name}
        />
        <div className={classes.container}>
          <MonthFilter
            onSubmit={({ month }) => handleFilterChange({ checkDate: month })}
            currentValue={checkDate}
          />

          <Filters
            defaultValues={DEFAULT_FILTERS}
            currentValues={{ query }}
            onSubmit={({ query: newQuery }) =>
              handleFilterChange({ query: newQuery })
            }
            placeholders={{ query: 'Search by Name, DOB, or MRN' }}
            showSearch
          />
        </div>

        <BillingOrders
          checkDate={checkDate}
          onPageChange={handlePageChange}
          page={page}
          practiceId={practiceId}
          query={query}
        />
      </div>
    )
  }

  return (
    <div>
      {error && <ListError description={error.message} onClose={clearError} />}
    </div>
  )
}
